import React from "react";
import DraggableFloater from "./DraggableFloater";

/**
 * PageLinks — drag-able floating pill row (default top-right) giving the
 * owner direct access to the new pages (Markets / Spend / History). Lives
 * inside a DraggableFloater so the owner can park it anywhere — position
 * persists in localStorage. Owner brief: "always make everything that is
 * added to a screen movable".
 */

function PageLinkPill({ href, label, glyph, testid }) {
  return (
    <a
      href={href}
      className="rc-panel px-3 py-1.5 text-[11px] rc-glow-text hover:opacity-80 transition-opacity inline-flex items-center gap-1.5"
      style={{ textDecoration: "none" }}
      data-testid={testid}
    >
      <span>{glyph}</span>
      <span>{label}</span>
    </a>
  );
}

export default function PageLinks() {
  return (
    <DraggableFloater
      storageKey="rawco-pagelinks-pos"
      initial={{ top: 48, right: 12 }}
      zIndex={40}
      className="flex gap-2"
      testid="page-links"
    >
      <PageLinkPill href="/trading" label="MARKETS" glyph="📈" testid="pagelink-trading" />
      <PageLinkPill href="/spend"   label="SPEND"   glyph="💷" testid="pagelink-spend" />
      <PageLinkPill href="/history" label="HISTORY" glyph="💬" testid="pagelink-history" />
    </DraggableFloater>
  );
}
